/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useCallback,
  useEffect,
  useReducer,
  useRef,
  useState,
} from "react";
import {
  Button,
  Col,
  Row,
  Typography,
  Input,
  Form,
  Modal,
  message,
  Select,
  Spin,
} from "antd";
import { Panel, PanelBody, PanelHeader } from "./panel";
import { CustomTiTle } from "./TitleStyle";
import { axios, getUser } from "../../../../../utils";
import { useHistory } from "react-router-dom";
import { createReducer, current } from "@reduxjs/toolkit";
import { eventRequest } from "../../../../../utils/useAxios";
import { AutoComplete } from "antdV4";
import dayjs from "dayjs";

const { Option } = AutoComplete;

const initState = {
  loading: false,
};

const reducer = createReducer(initState, {
  SET_LOADING: (state, { payload }) => {
    state.loading = payload;
  },
});

const RegisterInfo = ({ form }) => {
  const { getFieldDecorator, validateFields } = form;
  const history = useHistory();

  const [state, dispatch] = useReducer(reducer, initState);
  const loading = state.loading;
  const [registerData, setRegisterData] = useState(null);
  const [searchMember, setSearchMember] = useState("");
  const [searchMemberP, setSearchMemberP] = useState("");
  const [searchRef, setSearchRef] = useState("");
  const [memberList, setMemberList] = useState([]);
  const [selectMember, setSelectmember] = useState(0);
  const [onSearchMember, setOnSelectmember] = useState(false);
  const [teamList, setTeamList] = useState([]);
  const [honorList, setHonorList] = useState([]);
  const [regId, setRegId] = useState(null);
  const [eventId, setEventId] = useState(null);
  const [ticketData, setTicketData] = useState(null);
  const [userType, setUserType] = useState(null);
  const [isMember, setIsMember] = useState(false);
  const [isFreeze, setIsFreeze] = useState(false);
  const [sponsorData, setSponsorData] = useState({ status: false, text: "" });
  const [memberStatus, setMemberStatus] = useState({ status: false, text: "" });
  const [memberRegDate, setMemberRegDate] = useState(null);
  const [isOld, setIsOld] = useState(false);
  const [disabledRef, setDisabledRef] = useState(false);
  const [isSelect, setIsSelect] = useState(false);
  const [phoneErr, setPhoneErr] = useState("");
  const [status, setStatus] = useState(null);

  const phoneError = form.getFieldError("phone_no");
  const member_code = form.getFieldValue("member_code");

  const loadDataCallback = useCallback(async () => {
    const searchParams = new URLSearchParams(window.location.search);
    const serial = searchParams.get("serial");
    const registerId = searchParams.get("register_id");
    const eventId = searchParams.get("event_id");
    setRegId(registerId);
    if (registerId) {
      try {
        dispatch({ type: "SET_LOADING", payload: true });
        const data = await eventRequest.get(
          `/register-event/${registerId}`,
          {},
        );
        setRegisterData(data.data.data);
        let oldRegister = data.data.data;
        if (oldRegister) {
          setEventId(oldRegister.EventId);
          setIsOld(true);
          setUserType(oldRegister.OldUserType || oldRegister.UserType);
          form.setFieldsValue({
            first_name: oldRegister.FirstName,
            last_name: oldRegister.LastName,
            personal_no: oldRegister.PersonalNo,
            phone_no: oldRegister.PhoneNo,
            serial_no: oldRegister.TicketEvent[0].Serial,
            team_name: oldRegister.TeamName,
            honor_code: oldRegister.HonorCode,
            remark: oldRegister.TicketEvent[0].Remark,
            tiktok_id: oldRegister.TikTokId,
          });
          setMemberRegDate(oldRegister.MemberRegDate);

          if (oldRegister.RefName) {
            setDisabledRef(true);
            setSponsorData({
              status: true,
              text: oldRegister.RefName,
            });
            form.setFieldsValue({
              ref_code: oldRegister.RefCode,
            });
          }

          if (oldRegister.MemberCode) {
            form.setFieldsValue({
              member_code: oldRegister.MemberCode,
            });
            if (oldRegister.MemberCode === "110000001") {
              form.setFieldsValue({
                ref_code: null,
              });
              setSponsorData({ status: true, text: "" });
            }

            if (
              oldRegister.MemberCode.length == 9 ||
              oldRegister.MemberCode.length == 11
            ) {
              // setSearchMember(oldRegister.MemberCode);
              loadMemberDataCallback(oldRegister.MemberCode);
            }
          }
        }
        dispatch({ type: "SET_LOADING", payload: false });
      } catch (error) {
        dispatch({ type: "SET_LOADING", payload: false });
        message.error(error.message);
      }
    } else {
      try {
        dispatch({ type: "SET_LOADING", payload: true });
        const data = await eventRequest.get(
          `/tickets-event/serial/${serial}/event/${eventId}`,
          {},
        );
        setTicketData(data?.data?.data);

        dispatch({ type: "SET_LOADING", payload: false });
      } catch (error) {
        dispatch({ type: "SET_LOADING", payload: false });
        message.error(error.message);
      }
      form.setFieldsValue({
        serial_no: serial,
      });
    }
  }, [dispatch]);

  const loadMemberDataCallback = useCallback(
    async (memberCode) => {
      setMemberList([]);
      setSelectmember(0);
      const trimmedCode = memberCode.substring(0, 9);
      try {
        const data = await eventRequest.get(
          `/members-master/${trimmedCode}`,
          {},
        );
        const checkStatus = await eventRequest.get(
          `/members-master/status/${trimmedCode}`,
          {},
        );
        const { IsFound, IsStatus } = checkStatus.data;

        let status = false;
        let text = "";

        if (!IsFound) {
          text = "ไม่พบรหัสสมาชิก";
        } else if (IsFound && !IsStatus) {
          text = "ไม่อยู่ในสถานะที่ลงทะเบียนได้";
        } else {
          status = true;
        }

        setMemberStatus({ status, text });
        let list = [];
        if (data?.data[0]) {
          let resData = data.data[0];
          setIsMember(true);
          setMemberRegDate(resData.RegisterDate);
          let member = {
            code: resData.Code,
            firstName: resData.NameLocal,
            lastName: resData.SurnameLocal,
            personalNo: resData.IdentityCardNo || resData.Passport,
            phoneNo: resData.Mobile,
            teamName: resData.TeamName,
            honorCode: resData.HonorCode,
            refCode: resData.SponsorMemberCode,
          };
          let married = {
            code: resData.MarriedCode,
            firstName: resData.MarriedNameLocal,
            lastName: resData.MarriedSurnameLocal,
            personalNo: resData.MarriedIdentityCard || resData.MarriedPassport,
            phoneNo: resData.MarriedMobile,
            teamName: resData.TeamName,
            honorCode: resData.HonorCode,
            refCode: resData.SponsorMemberCode,
          };
          setIsFreeze(resData.IsFreeze);
          if (resData.SponsorMemberCode) {
            setDisabledRef(true);
            setSponsorData({
              status: true,
              text: resData.SponsorMemberName,
            });
          } else {
            setSponsorData({
              status: true,
              text: "",
            });
          }

          if (memberCode !== resData.Code) {
            form.resetFields([
              "first_name",
              "last_name",
              "personal_no",
              "phone_no",
              "tiktok_id",
              "team_name",
              "honor_code",
              "ref_code",
              "remark",
            ]);
            // setSponsorData({ status: false, text: "" });
            setMemberRegDate(null);
            setMemberList([]);
            if (resData.IsFreeze) {
              // 1, 1||0
              setSponsorData({ status: false, text: "" });
              setMemberStatus({
                status: false,
                text: "ไม่พบรหัสสมาชิก",
              });
            } else if (!resData.IsFreeze) {
              if (resData.IsMarried) {
                // 0, 1
                if (resData.MarriedStatus === "Pending") {
                  setSponsorData({ status: false, text: "" });
                  setMemberStatus({
                    status: false,
                    text: "รหัสคู่ยังไม่ได้รับการอนุมัติ กรุณาติดต่อเจ้าหน้าที่",
                  });
                } else if (resData.MarriedStatus === "Active") {
                  list.push(married);
                  setMemberRegDate(resData.RegisterDate);
                }
              } else if (!resData.IsMarried) {
                // 0, 0
                setSponsorData({ status: false, text: "" });
                setMemberStatus({
                  status: false,
                  text: "ไม่พบรหัสสมาชิก",
                });
              }
            } else {
              list.push(married);
            }
          } else {
            if (resData.IsFreeze) {
              form.resetFields([
                "first_name",
                "last_name",
                "personal_no",
                "phone_no",
                "tiktok_id",
                "team_name",
                "honor_code",
                "ref_code",
                "remark",
              ]);
              setSponsorData({ status: false, text: "" });
              setMemberRegDate(null);
              setMemberList([]);
              setMemberStatus({
                status: false,
                text: "รหัสสมาชิกนี้ไม่สามารถลงทะเบียนได้ กรุณาติดต่อเจ้าหน้าที่",
              });
              return;
            }
            list.push(member);
            if (resData.IsMarried && !resData.IsFreeze && married?.firstName) {
              list.push(married);
            }
          }
        } else {
          setIsMember(false);
        }
        setMemberList(list);
      } catch (error) {
        message.error(error.message);
      }
    },
    [dispatch],
  );

  const loadMemberDataWithPersonalCallback = useCallback(
    async (idCard) => {
      setMemberList([]);
      setSelectmember(0);
      try {
        const checkStatus = await eventRequest.get(
          `/members-master/check-status/${idCard}`,
          {},
        );
        setStatus(checkStatus?.data?.status);
        const allowStatus = ["Active", "Pending", "Waiting", "Expired"];
        if (allowStatus.includes(checkStatus?.data?.status)) {
          const data = await eventRequest.get(
            `/members-master/personal/${idCard}`,
            {},
          );
          if (data?.data) {
            setIsMember(true);
            setMemberRegDate(data.data.memberRegDate);
            form.setFieldsValue({
              member_code: data.data.code,
              first_name: data.data.firstName,
              last_name: data.data.lastName,
              phone_no: data.data.phone,
              team_name: data.data.teamName,
              honor_code: data.data.honorCode,
              ref_code: data.data.refCode,
              tiktok_id: null,
            });
            if (data.data.refCode) {
              setDisabledRef(true);
              setSponsorData({
                status: true,
                text: data.data.refName,
              });
            } else {
              setIsMember(false);
              setSponsorData({
                status: false,
                text: "",
              });
            }
            setMemberList([]);
            setSelectmember(0);
          }
        }
      } catch (error) {
        message.error(error.message);
      }
    },
    [dispatch],
  );

  const loadRefDataCallback = useCallback(
    async (memberCode, oldRegister) => {
      try {
        const data = await eventRequest.get(
          `/members-master/${memberCode}`,
          {},
        );
        if (data.data[0] && !isMember) {
          form.setFieldsValue({
            team_name: oldRegister?.TeamName
              ? oldRegister?.TeamName
              : data.data[0].TeamName,
            // honor_code: oldRegister?.HonorCode ? oldRegister?.HonorCode : data.data[0].HonorCode,
          });
          if (data.data[0]) {
            setSponsorData({
              status: true,
              text: [data.data[0].NameLocal, data.data[0].SurnameLocal]
                .filter(Boolean)
                .join(" "),
            });
            form.setFields({
              ref_code: {
                value: form.getFieldValue("ref_code"),
                errors: null,
              },
            });
          } else {
            setSponsorData({ status: false, text: "" });
          }
        }
      } catch (error) {
        message.error(error.message);
      }
    },
    [dispatch],
  );

  const loadTeamDataCallback = useCallback(async () => {
    setTeamList([]);
    try {
      const data = await eventRequest.get(`/members-master/master/team`, {});
      let list = [];
      if (data) {
        for (const team of data.data.items) {
          list.push(team.TeamName);
        }
      }
      setTeamList(list);
    } catch (error) {
      message.error(error.message);
    }
  }, [dispatch]);

  const loadHonorDataCallback = useCallback(async () => {
    setHonorList([]);
    try {
      const data = await eventRequest.get(`/members-master/master/honor`, {});
      let list = [];
      if (data) {
        for (const honor of data.data.items) {
          list.push(honor.HonorCode);
        }
      }
      list.push("Member", "BB", "BO");
      setHonorList(list);
    } catch (error) {
      message.error(error.message);
    }
  }, [dispatch]);

  const onFinish = (values) => {
    if (
      memberStatus.status === false ||
      ["Legal", "Blacklist"].includes(status)
    ) {
      return;
    }
    console.log("values ", values);

    const user = getUser();
    let data = {
      registerId: regId,
      ticketId: registerData?.TicketId ? registerData?.TicketId : ticketData.Id,
      eventId: registerData?.EventId
        ? registerData?.EventId
        : ticketData.EventId,
      // userType: registerData?.UserType ? registerData?.UserType : userType,
      userType: "backOffice",
      oldUserType: userType,
      memberCode: values.member_code,
      fName: values.first_name,
      lName: values.last_name,
      phoneNo: values.phone_no,
      personalNo: values.personal_no,
      teamName: values.team_name,
      honorCode: values.honor_code,
      // updatedBy: user.user_code,
      // updatedByName: user.name,
      tikTokId: values.tiktok_id,
      remark: values.remark,
      useFreeze: isFreeze,
      memberRegDate: memberRegDate,
      // createFromUpdate: true
    };
    if (values.ref_code) {
      data.refCode = values.ref_code;
      data.refName = sponsorData.text;
    }
    if (values.member_code === "110000001") {
      data.refCode = null;
    }
    if (!registerData) {
      // data.createFromUpdate = true
      data.createdBy = user.user_code;
      data.createdByName = user.name;
    } else {
      data.updatedBy = user.user_code;
      data.updatedByName = user.name;
    }
    Modal.confirm({
      title: "ยืนยันการทำรายการ",
      content: "ต้องการแก้ไขข้อมูลการลงทะเบียนนี้หรือไม่?",
      okText: "ยืนยัน",
      cancelText: "ปิด",
      onOk() {
        return new Promise((resolve, reject) => {
          registerData
            ? axios({
                method: "patch",
                baseURL: process.env.REACT_APP_EVENT_URL_API,
                url: "register-event/update",
                data,
              })
                .then((res) => {
                  console.log(res);
                  resolve("success");
                })
                .catch((err) => {
                  console.log(err);
                  reject(
                    err && err.response
                      ? err.response.data.message
                        ? err.response.data.message
                        : err.response.data
                      : err.message,
                  );
                })
            : !registerData && data.memberCode
              ? axios({
                  method: "post",
                  baseURL: process.env.REACT_APP_EVENT_URL_API,
                  url: "register-event/staff",
                  data,
                })
                  .then((res) => {
                    console.log(res);
                    resolve("success");
                  })
                  .catch((err) => {
                    console.log(err);
                    reject(
                      err && err.response
                        ? err.response.data.message
                          ? err.response.data.message
                          : err.response.data
                        : err.message,
                    );
                  })
              : axios({
                  method: "post",
                  baseURL: process.env.REACT_APP_EVENT_URL_API,
                  url: "register-event/not-login",
                  data,
                })
                  .then((res) => {
                    console.log(res);
                    resolve("success");
                  })
                  .catch((err) => {
                    console.log(err);
                    reject(
                      err && err.response
                        ? err.response.data.message
                          ? err.response.data.message
                          : err.response.data
                        : err.message,
                    );
                  });
        })
          .then(() => {
            Modal.success({
              title: "สำเร็จ",
              content: "แก้ไขการลงทะเบียนเรียบร้อย",
              okText: "ปิด",
              onOk() {
                history.push("/events/ticket", {
                  from: history.location.pathname,
                });
                // window.location.href = `/events/ticket`
              },
            });
          })
          .catch((reason) => {
            Modal.error({
              title: "ไม่สามารถแก้ไขข้อมูลได้",
              content: reason,
              okText: "ปิด",
            });
          });
      },
    });
  };

  const handleChange = (select) => {
    setSelectmember(select.key);
    setOnSelectmember(true);
    setIsSelect(true);
  };

  const handleInputReplaceTikTokId = (text) => {
    if (!text) return ""; // ถ้าว่าง ให้คืนค่าว่างเลย

    // ลบทุกอย่างที่ไม่ใช่ a-z, A-Z, 0-9, _, .
    const cleaned = text.replace(/[^a-zA-Z0-9_.]/g, "");

    // ลบ @ ทั้งหมด
    const noExtraAt = cleaned.replace(/@/g, "");

    // ใส่ @ ข้างหน้าเฉพาะถ้าไม่ว่าง
    return noExtraAt
      ? noExtraAt.startsWith("@")
        ? noExtraAt
        : `@${noExtraAt}`
      : "";
  };

  // const handleSearchMember = (e, isEnter = false) => {
  //   const value = e.target.value;
  //   setIsOld(false);
  //   setMemberRegDate(null);
  //   setIsMember(false);
  //   setSearchMember(value);
  //   setOnSelectmember(true);
  //   setDisabledRef(false);
  //   if (isEnter && (value?.length === 9 || value?.length === 11)) {
  //     loadMemberDataCallback(value);
  //   }
  // };

  const MEMBER_SEARCH_PATTERN = /^\d{9}$|^\d{9}\.2$/;
  const clampMemberInput = (raw = "") => {
    let v = String(raw).replace(/[^\d.]/g, ""); // ตัดทุกอย่างที่ไม่ใช่เลข/จุด

    // จุดได้แค่ 1 ตัว
    const dot = v.indexOf(".");
    if (dot !== -1) {
      v = v.slice(0, dot + 1) + v.slice(dot + 1).replace(/\./g, "");
    }

    // max 11
    if (v.length > 11) v = v.slice(0, 11);

    // ก่อนครบ 9 หลัก ห้ามมีจุด
    if (v.length <= 9) return v.replace(/\./g, "");

    const first9 = v.slice(0, 9).replace(/\D/g, "");
    let rest = v.slice(9);

    // ตัวที่10 ต้องเป็น .
    if (rest[0] !== ".") {
      return first9;
    }

    // ตัวที่11 ถ้ามี ต้องเป็น 2 เท่านั้น
    if (rest.length >= 2) {
      rest = rest[1] === "2" ? ".2" : ".";
    }

    // ห้ามเกิน .2
    if (rest.length > 2) rest = ".2";

    return first9 + rest;
  };

  const lastSearchRef = useRef("");
  const resetMemberState = () => {
    setIsOld(false);
    setMemberRegDate(null);
    setIsMember(false);
    setOnSelectmember(true);
    setDisabledRef(false);
    setSearchMember(null);
    setMemberList([]);
    setStatus(null);
    form.resetFields(["personal_no", "honor_code"]);
  };

  const handleMemberInputChange = (e, { force = false } = {}) => {
    resetMemberState();
    const raw = e?.target?.value ?? "";
    const v = clampMemberInput(raw);
    setSearchMember(v);

    // search เฉพาะตอนเข้า pattern
    if (MEMBER_SEARCH_PATTERN.test(v)) {
      // กันยิงซ้ำ
      if (!force && lastSearchRef.current === v) return;

      lastSearchRef.current = v;
      loadMemberDataCallback(v);
    } else {
      // ถ้าไม่ match แล้วค้นหาได้ใหม่เมื่อกลับมา match
      lastSearchRef.current = "";
    }
  };

  const handleSearchMemberByPersonal = (e, isEnter = false) => {
    const value = e.target.value;
    setIsOld(false);
    setIsMember(false);
    setSearchMemberP(value);
    setDisabledRef(false);
    if (isEnter && value?.length >= 9) {
      loadMemberDataWithPersonalCallback(value);
    }
  };

  const handleSeachRef = (e, isEnter = false) => {
    const value = e.target.value;
    if (!isMember) {
      form.resetFields(["team_name", "honor_code"]);
    }
    setSponsorData({ status: false, text: "" });
    setSearchRef(value);
    if (isEnter && /^\d{9}$/.test(value)) {
      loadRefDataCallback(value, registerData);
    }
  };

  const handleCancelRegister = (id) => {
    Modal.confirm({
      type: "warning",
      title: "ยืนยันการทำรายการ",
      content: "คุณต้องการยกเลิกการลงทะเบียนหรือไม่?",
      okText: "ยืนยัน",
      okType: "danger",
      cancelText: "ปิด",
      onOk() {
        const searchParams = new URLSearchParams(window.location.search);
        const serial = searchParams.get("serial");
        return new Promise((resolve, reject) => {
          eventRequest
            .delete(`/register-event/${id}`)
            .then(() => resolve())
            .catch((err) =>
              reject(
                err && err.response
                  ? err.response.data.message
                    ? err.response.data.message
                    : err.response.data
                  : err.message,
              ),
            );
        })
          .then(() => {
            Modal.success({
              title: "สำเร็จ",
              content: "ยกเลิกการลงทะเบียนเรียบร้อย",
              okText: "ปิด",
              onOk() {
                window.location.href = `/events/edit-register?event_id=${eventId}&serial=${serial}`;
              },
            });
          })
          .catch((reason) => {
            console.log("reason ", reason);

            Modal.error({
              title: "ผิดพลาด",
              content: reason,
              okText: "ปิด",
            });
          });
      },
    });
  };

  useEffect(() => {
    loadDataCallback();
    loadTeamDataCallback();
    loadHonorDataCallback();
  }, [loadDataCallback, loadTeamDataCallback, loadHonorDataCallback]);

  useEffect(() => {
    setMemberStatus({ status: true, text: "" });
    resetMemberState();
    if (searchMember?.length == 9 || searchMember?.length == 11) {
      loadMemberDataCallback(searchMember);
    }
  }, [searchMember]);

  useEffect(() => {
    setDisabledRef(false);
    if (searchMemberP?.length >= 9) {
      loadMemberDataWithPersonalCallback(searchMemberP);
    }
  }, [searchMemberP]);

  useEffect(() => {
    if (/^\d{9}$/.test(searchRef)) {
      loadRefDataCallback(searchRef, registerData);
    }
  }, [searchRef]);

  // useEffect(() => {
  //   if (memberList.length && !isOld) {
  //     form.setFieldsValue({
  //       member_code: isSelect ? memberList[selectMember].code : member_code,
  //       first_name: memberList[selectMember].firstName,
  //       last_name: memberList[selectMember].lastName,
  //       personal_no: memberList[selectMember].personalNo,
  //       phone_no: memberList[selectMember].phoneNo,
  //       team_name: memberList[selectMember].teamName,
  //       honor_code: memberList[selectMember].honorCode,
  //       ref_code: memberList[selectMember].refCode,
  //       tiktok_id: null,
  //     });
  //     setIsSelect(false);
  //   }
  // }, [memberList, selectMember, onSearchMember, isSelect]);

  useEffect(() => {
    if (!memberList?.length) return;
    if (isOld && !isSelect) {
      return form.setFieldsValue({
        member_code: registerData?.MemberCode,
        first_name: registerData?.FirstName,
        last_name: registerData?.LastName,
        personal_no: registerData?.PersonalNo,
        phone_no: registerData?.PhoneNo,
        team_name: registerData?.TeamName,
        honor_code: registerData?.HonorCode,
        ref_code: registerData?.RefCode,
        tiktok_id: registerData?.TikTokId,
        remark: registerData?.TicketEvent[0]?.Remark,
      });
    }
    // if (!isSelect) return;

    const m = memberList[selectMember];
    if (!m) return;
    if (member_code?.length !== 9 && member_code?.length !== 11) {
      resetMemberState();
    }
    form.setFieldsValue({
      // member_code: m.code,
      member_code: isSelect ? m.code : member_code,
      first_name: m.firstName,
      last_name: m.lastName,
      personal_no: m.personalNo,
      phone_no: m.phoneNo,
      team_name: m.teamName,
      honor_code: m.honorCode,
      ref_code: m.refCode,
      tiktok_id: null,
      remark: null,
    });

    setIsSelect(false);
  }, [memberList, selectMember, isOld]);

  useEffect(() => {
    if (member_code === "110000001") {
      form.setFieldsValue({
        ref_code: null,
      });
      setSponsorData({ status: true, text: "" });
    }
  }, [member_code]);

  return (
    <Spin spinning={loading}>
      <Form onSubmit={onFinish}>
        <Typography
          style={{
            fontWeight: 600,
            fontSize: "28px",
            lineHeight: "42px",
            color: "rgba(0, 0, 0, 0.85)",
          }}
        >
          แก้ไขข้อมูลการลงทะเบียน
        </Typography>
        <Panel>
          <PanelHeader>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                height: "32px",
              }}
            >
              <p style={{ margin: 0 }}>รายละเอียดการลงทะเบียน</p>

              {regId && (
                <Button
                  type="danger"
                  onClick={() => handleCancelRegister(regId)}
                >
                  ล้างข้อมูล
                </Button>
              )}
            </div>
          </PanelHeader>
          <PanelBody>
            <Row gutter={[48, 16]} className="mb-3">
              <Col md={12} style={{ height: "82px" }}>
                <CustomTiTle title={"รหัสสมาชิก"} notReq={true} />
                <Form.Item>
                  {/* {getFieldDecorator(
                    "member_code",
                    {},
                  )(
                    <Input
                      placeholder="รหัสสมาชิก"
                      allowClear
                      onChange={(e) => handleSearchMember(e)}
                      onPressEnter={(e) => handleSearchMember(e, true)}
                    />,
                  )} */}
                  {getFieldDecorator("member_code", {
                    //  clamp เพื่อห้ามพิมพ์ผิด
                    getValueFromEvent: (e) =>
                      clampMemberInput(e?.target?.value),
                  })(
                    <Input
                      placeholder="รหัสสมาชิก"
                      allowClear
                      onChange={handleMemberInputChange}
                      onPressEnter={(e) => {
                        e.preventDefault();
                        handleMemberInputChange(e, { force: true });
                      }}
                    />,
                  )}
                  {memberRegDate ? (
                    <p
                      style={{
                        margin: 0,
                        height: "10px",
                        marginTop: "-10px",
                      }}
                    >
                      วันที่สมัคร : {dayjs(memberRegDate).format("DD/MM/YYYY")}
                    </p>
                  ) : (
                    <p
                      style={{
                        margin: 0,
                        height: "10px",
                        marginTop: "-10px",
                        color: "#f5222d",
                      }}
                    >
                      {memberStatus.text}
                    </p>
                  )}
                </Form.Item>
              </Col>

              <Col md={12}>
                {memberList.length > 1 ? ( //&& searchMember
                  <>
                    <CustomTiTle title={"เลือกสมาชิก"} notReq={true} />
                    <Select
                      labelInValue
                      defaultValue={{ key: 0 }}
                      // onChange={(e) => handleChange(e)}
                      onSelect={(value, option) => handleChange(value)}
                      style={{
                        marginTop: "4px",
                        marginBottom: "4px",
                      }}
                    >
                      {memberList.map((member, index) => (
                        <Option key={index} value={index}>
                          {member.firstName} {member.lastName}
                        </Option>
                      ))}
                    </Select>
                  </>
                ) : (
                  <></>
                )}
              </Col>
            </Row>
            <Row gutter={[48, 16]} className="mb-3">
              <Col md={12}>
                <CustomTiTle title={"ชื่อ"} />
                <Form.Item>
                  {getFieldDecorator("first_name", {
                    rules: [
                      {
                        required: true,
                        message: "กรุณาระบุชื่อ",
                      },
                    ],
                  })(<Input placeholder="ชื่อ" allowClear />)}
                </Form.Item>

                <CustomTiTle title={"นามสกุล"} notReq={true} />
                <Form.Item>
                  {getFieldDecorator("last_name", {
                    rules: [
                      // {
                      //   required: true,
                      //   message: "กรุณาระบุนามสกุล",
                      // },
                    ],
                  })(<Input placeholder="นามสกุล" allowClear />)}
                </Form.Item>

                <CustomTiTle title={"เลขบัตรประจำตัวประชาชน/Passport No."} />
                <Form.Item>
                  {getFieldDecorator("personal_no", {
                    rules: [
                      {
                        required: true,
                        message: "กรุณาระบุเลขบัตรประจำตัวประชาชน/Passport No.",
                      },
                    ],
                  })(
                    <Input
                      placeholder="เลขบัตรประจำตัวประชาชน/Passport No."
                      allowClear
                      onChange={(e) => {
                        // setIsOld(false);
                        form.resetFields("member_code");
                        resetMemberState();
                        handleSearchMemberByPersonal(e);
                      }}
                      onPressEnter={(e) => {
                        // setIsOld(false);
                        form.resetFields("member_code");
                        resetMemberState();
                        handleSearchMemberByPersonal(e, true);
                      }}
                    />,
                  )}
                  {["Legal", "Blacklist"].includes(status) && (
                    <p
                      style={{
                        margin: 0,
                        marginBottom: "-21px",
                        color: "#f5222d",
                        lineHeight: "normal",
                      }}
                    >
                      เลขบัตรประจำตัวประชาชน/Passport No.
                      นี้ไม่สามารถลงทะเบียนได้ กรุณาติดต่อเจ้าหน้าที่
                    </p>
                  )}
                </Form.Item>

                <CustomTiTle title={"เบอร์โทรศัพท์"} />
                <Form.Item
                  validateStatus={phoneErr || phoneError ? "error" : ""}
                  help={phoneErr || phoneError}
                >
                  {getFieldDecorator("phone_no", {
                    rules: [
                      {
                        required: true,
                        message: "กรุณาระบุเบอร์โทรศัพท์",
                      },
                    ],
                    normalize: (value) => {
                      if (!value) return value;
                      return value.replace(/\D/g, "").slice(0, 10);
                    },
                  })(
                    <Input
                      placeholder="เบอร์โทรศัพท์"
                      allowClear
                      maxLength={10}
                      onChange={() => setPhoneErr("")}
                    />,
                  )}
                </Form.Item>
                {/* {userType === "notLogin" && (
                  <>
                    <CustomTiTle title={"@TikTok"} notReq={true} />
                    <Form.Item>
                      {getFieldDecorator(
                        "tiktok_id",
                        {}
                      )(<Input placeholder="@ชื่อTikTok" allowClear />)}
                    </Form.Item>
                  </>
                )} */}
                {/* {userType === "notLogin" && (
                  <> */}
                <CustomTiTle title="@TikTok" notReq={true} />
                <Form.Item>
                  {getFieldDecorator("tiktok_id", {
                    normalize: (value) => handleInputReplaceTikTokId(value),
                  })(
                    <Input
                      placeholder="@ชื่อTikTok"
                      disabled={isMember || member_code === "110000001"}
                      allowClear
                    />,
                  )}
                </Form.Item>
                {/* </>
                )} */}
              </Col>

              <Col md={12}>
                <CustomTiTle title={"Team Name"} notReq={true} />
                <Form.Item>
                  {getFieldDecorator(
                    "team_name",
                    {},
                  )(
                    <Select
                      showSearch
                      placeholder="Select Team Name"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {teamList.length &&
                        teamList.map((teamName, index) => (
                          <Option key={index} value={teamName}>
                            {teamName}
                          </Option>
                        ))}
                    </Select>,
                  )}
                </Form.Item>

                <CustomTiTle title={"Honor Code"} notReq={true} />
                <Form.Item>
                  {getFieldDecorator(
                    "honor_code",
                    {},
                  )(
                    <Select
                      showSearch
                      placeholder="Select Honor Code"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {honorList.length &&
                        honorList.map((honorCode, index) => (
                          <Option key={index} value={honorCode}>
                            {honorCode}
                          </Option>
                        ))}
                    </Select>,
                  )}
                </Form.Item>

                <CustomTiTle
                  title={"รหัสผู้แนะนำ"}
                  notReq={member_code === "110000001"}
                />
                <Form.Item>
                  {getFieldDecorator("ref_code", {
                    rules: [
                      {
                        required: member_code === "110000001" ? false : true,
                        message: "กรุณาระบุรหัสผู้แนะนำ",
                      },
                      {
                        validator: (rule, value, callback) => {
                          if (!value) {
                            callback();
                            return;
                          }

                          // Check if the value is a number
                          if (!/^\d+$/.test(value)) {
                            callback("กรุณาระบุเป็นตัวเลขเท่านั้น");
                            return;
                          }

                          // Check if it starts with "110" and has exactly 6 additional digits
                          if (!/^110\d{6}$/.test(value)) {
                            callback("รูปแบบรหัสผู้แนะนำไม่ถูกต้อง");
                            return;
                          }

                          if (sponsorData.status === false) {
                            callback("ไม่พบรหัสผู้แนะนำ");
                            return;
                          }

                          callback(); // Validation passed
                        },
                      },
                    ],
                  })(
                    <Input
                      placeholder="110xxxxxx"
                      allowClear
                      onChange={(e) => handleSeachRef(e)}
                      onPressEnter={(e) => handleSeachRef(e, true)}
                      disabled={disabledRef}
                    />,
                  )}
                  <p
                    style={{
                      margin: 0,
                      height: "10px",
                      marginTop: "-10px",
                    }}
                  >
                    {sponsorData.text}
                  </p>
                </Form.Item>

                <CustomTiTle title={"รหัสบัตรงาน"} notReq={true} />
                <Form.Item>
                  {getFieldDecorator(
                    "serial_no",
                    {},
                  )(<Input placeholder="รหัสบัตรงาน" disabled />)}
                </Form.Item>
              </Col>
            </Row>
            <CustomTiTle title={"หมายเหตุ"} notReq={true} />
            <Form.Item>
              {getFieldDecorator(
                "remark",
                {},
              )(<Input placeholder="เพิ่มหมายเหตุ" allowClear />)}
            </Form.Item>
          </PanelBody>
        </Panel>

        <Form.Item>
          <Row gutter={[24, 16]} type="flex" justify="center">
            <Col>
              <Button
                type="danger"
                ghost
                onClick={() => {
                  history.push("/events/ticket", {
                    from: history.location.pathname,
                  });
                }}
                style={{
                  width: "140px",
                  height: "47px",
                  padding: "10px 35px",
                  borderRadius: "12px",
                }}
              >
                ยกเลิก
              </Button>
            </Col>

            <Col>
              <Button
                type="primary"
                onClick={() => {
                  const phone = form.getFieldValue("phone_no");
                  if (phone && phone.length !== 10) {
                    setPhoneErr("กรุณาระบุให้ครบ 10 หลัก");
                    return;
                  }

                  validateFields((err, values) => {
                    if (!err) {
                      onFinish(values);
                    }
                  });
                }}
                style={{
                  width: "140px",
                  height: "47px",
                  padding: "10px 35px",
                  borderRadius: "12px",
                }}
              >
                บันทึก
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </Spin>
  );
};

export default Form.create("edit-register")(RegisterInfo);
